import React, { useContext } from 'react';
import ModalComponent from 'molecules/Modal';
import { ButtonComp, ButtonType, ContainedButton } from 'atoms/Buttons';
import { useDispatch, useSelector } from 'react-redux';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { getIndulgentAddOnCardSize } from 'organisms/CartPage/AU/Utils/cartPageUtils';
import {
  getFullImagePath,
  isEmptyEvery,
  toastifyFn,
  getPrice,
  getMainImagePath,
  toastifyFnWithImage,
  getBackgroundImagePath,
  getBackgroundImageSrc,
  getUserType,
} from 'common/utilities/utils';
import { computeSurgePrice } from 'organisms/MenuPDPPage/AU/Utilities/MenuPDPUtils';
import ImageComponent from 'atoms/Image';
import { UserOrderContext } from 'context/context';
import { indulgentAddToCartHandler } from '../../Utils/cartPageUtils';
import { LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

export const setPrevArrowCSS = currentSlide => {
  let elmnt = document.getElementsByClassName('slick-prev')[0] || {
    style: {
      display: 'block',
    },
  };
  if (currentSlide > 0) {
    elmnt.style.display = 'block';
  } else {
    elmnt.style.display = 'none';
  }
};
export const getImage = (content, tenantReducer, imageContainerSize) => {
  return content ? (
    <ImageComponent
      data-testid=''
      className='indulgentaddOns-card-image-global'
      defaultPath={getFullImagePath(null, tenantReducer, true)}
      srcFile={getMainImagePath(content, imageContainerSize.containerWidth, imageContainerSize.containerWidth)}
    />
  ) : null;
};
/**
 * Render login form in a popup modal Component
 * @param {*} props - Object
 */
export const IndulgentAddOn = props => {
  const {
    isMobile,
    openIndulgentModal,
    handleClose,
    removeItemCart,
    IndulgentData,
    modalTitle,
    continueButtonText,
    toastMassage,
    callBackMethod,
    imageContainerSize,
    addToCart,
    productId = '',
    ruleNameDetails = {},
  } = props;
  const { ruleName, recommendationType = '' } = ruleNameDetails;
  const { INDULGENT_ADD_ON } = CART_PAGE_CONSTANTS;
  const { ADD_TO_CART } = INDULGENT_ADD_ON;
  const { userOrderState } = useContext(UserOrderContext);
  const dispatch = useDispatch();
  const { tickWhiteToast } = IMAGE_PATH;
  const { cartReducer, userParams, tenantReducer, storesReducer, menuReducer, marketConfigReducer } = useSelector(
    data => {
      return {
        cartReducer: data.cartReducer || {},
        userParams: data.appStateReducer.userStatus || {},
        tenantReducer: data.tenantReducer || {},
        storesReducer: data.storesReducer || {},
        menuReducer: data.menuReducer || {},
        marketConfigReducer: data?.marketConfigReducer?.response,
      };
    },
  );
  const { headerData: { pdpBackgroundImage = {} } = {} } = marketConfigReducer;
  const backgroundImageData = getBackgroundImagePath(pdpBackgroundImage);
  const { flatResponse = {} } = menuReducer || {};
  const storeTimeZone =
    storesReducer?.storesWithStatus?.length && storesReducer?.storesWithStatus[0]?.summary?.timeZoneIANA;
  const { loggedIn, localized } = userParams;
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW))
    : userOrderState.dispositionNew;
  const storeInfo = dispositionNew ? dispositionNew.store : {};
  const catalogs =
    (storeInfo?.summary?.menu?.catalogs?.length && storeInfo?.summary?.menu?.catalogs[0]) ||
    tenantReducer?.genericMenuName ||
    '';

  const modalProps = {
    id: 'DispositionModulePopup',
    role: 'dialog',
    modalTitleId: 'add-ons-modal',
    show: openIndulgentModal,
    classNames: 'indulgent-addons-modal extra-small-modal',
    showCloseBtn: !cartReducer?.isAddItemLoading,
    closeDataTestId: 'indulgent-close-handler',
    closeButtonHandler: handleClose,
    modalTitle: translateWithI18Next(modalTitle),
    autoFocus: true,
  };
  const imageBackgroundSize = getIndulgentAddOnCardSize(isMobile);
  const backgroundStyle = () =>
    getBackgroundImageSrc(backgroundImageData, imageBackgroundSize.cardWidth, imageBackgroundSize.cardHeight);
  const surgePriceObj = availability => {
    if (availability.length > 1) {
      return computeSurgePrice(availability, storeTimeZone);
    } else {
      return availability[0];
    }
  };
  const userType = getUserType(localized, loggedIn);

  return (
    <div className='cart-indulgent-global'>
      {openIndulgentModal && !removeItemCart && localized && (
        <ModalComponent {...modalProps}>
          <div className='indulgent-container-global'>
            <div className='indulgent-card-list-global'>
              {IndulgentData?.map((product, i) => {
                return (
                  <div key={product?.id} style={backgroundStyle()} className='indulgent-card-global'>
                    {getImage(product?.content, tenantReducer, imageContainerSize)}
                    <div className='indulgentaddOns-card-content-global'>
                      <div className='indulgent-card-header-global'>{product?.dname[0]?.value}</div>
                      <div className='indulgent-card-price-global'>
                        {tenantReducer?.currencySymbol}
                        {getPrice(
                          surgePriceObj(product?.availability),
                          tenantReducer?.currencyConversionFactor,
                          storeTimeZone,
                        ).toFixed(2)}
                      </div>
                      <ContainedButton
                        variant={ButtonType.primary}
                        aria-label={translateWithI18Next(ADD_TO_CART) + ' ' + product?.dname[0]?.value}
                        data-testid={`add-to-cart-global-${i}`}
                        onClickHandler={event => {
                          indulgentAddToCartHandler({
                            index: i,
                            id: product?.id,
                            customizable: false,
                            dispatch,
                            cartReducer,
                            tenantReducer,
                            catalogs,
                            flatResponse,
                            category_id: product?.categoryId,
                            userType,
                            productId,
                            ruleName,
                            recommendationType,
                            IndulgentData,
                          });
                          event.preventDefault();
                          event.stopPropagation();
                          if (callBackMethod) {
                            let imageTemplate = <ImageComponent srcFile={tickWhiteToast} />;
                            toastifyFnWithImage(
                              translateWithI18Next(toastMassage),
                              imageTemplate,
                              'pdp-indulgent-toast pdp-modal-toast',
                            );
                            callBackMethod(product?.id);
                          } else {
                            toastifyFn(translateWithI18Next(toastMassage), '', 'cart-toast-alert');
                          }
                        }}
                      >
                        {translateWithI18Next(addToCart)}
                      </ContainedButton>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className='ContinueButton'>
              <ButtonComp
                className='button redButton indulgent-card-button'
                data-testid='continue-to-cart'
                disabled={cartReducer?.isAddItemLoading}
                onClickHandler={handleClose}
              >
                {translateWithI18Next(continueButtonText)}
              </ButtonComp>
            </div>
          </div>
        </ModalComponent>
      )}
    </div>
  );
};

export default IndulgentAddOn;
